import React, { useMemo, useCallback } from "react";
import styled from "styled-components";
import { Row, theme } from "uikit";

import Parking from "../../../../../../../services/Parking2";
import { useTypedSelector } from "../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../LightTable";
import { useFilteredExecutors } from "../../../../../hook";

const StyledCell = styled(Row)<{ active: boolean; background?: string }>`
	padding: 9px 6px;
	color: ${(props) => (props.active ? props.color : "lightgray")} !important;
	background: ${(props) => props?.background || "transparent"};
	width: 100%;
	display: flex;
	gap: 5px;
	font-size: 12px;
	white-space: wrap;
	align-items: center;
	z-index: 1000;

	${theme.longWord}
`;

const DriversAmountCellContent: React.FC<DriversAmountCellContent.Props> = ({
	item,
}) => {
	const executors = useTypedSelector(
		(state) => state.orders.executors.data.executors,
	);

	const { criteria: filters } = useTypedSelector(
		(state) => state.orders.parking.filter,
	);

	const filteredExecutors = useFilteredExecutors(
		executors,
		{
			companyIds: filters.companyIds,
			taxiServiceIds: filters.taxiServiceIds,
			executorGroupIds: filters.executorGroupIds,
		},
		{
			companyIds: true,
			taxiServiceIds: true,
			executorGroupIds: true,
		},
	);

	const getExecutorById = useCallback(
		(id: number) => {
			const exist = filteredExecutors.find((item) => item.id === id);
			return exist;
		},
		[filteredExecutors],
	);

	const content = useMemo(() => {
		const numberLength: number = item.executorsQueue?.length
			? (
					item.executorsQueue?.filter((queue) =>
						getExecutorById(queue.executor?.id || -3),
					) || []
			  ).length
			: 0;

		return numberLength;
	}, [getExecutorById, item.executorsQueue]);

	return (
		<CellContentRoot
			alignItems="center"
			w="100%"
			h="100%"
			p="0"
			cursor="pointer"
			style={{ fontSize: 14 }}
		>
			<StyledCell active={item.active} justify="center">
				{content}
			</StyledCell>
		</CellContentRoot>
	);
};

declare namespace DriversAmountCellContent {
	interface Props {
		item: Parking.Model;
	}
}

export default DriversAmountCellContent;
